const PARTNERS = [
  {
    name: 'Legrand',
    logo: 'https://storage.readdy-site.link/project_files/d19cdf12-b626-4056-8bec-014908ede6b4/c021b7e2-dded-4457-b864-dd60fb6b7c7f_legrand.png?v=401c688b447ef093738a92388a1bee57',
    scale: 1.4,
  },
  {
    name: 'Furukawa',
    logo: 'https://storage.readdy-site.link/project_files/d19cdf12-b626-4056-8bec-014908ede6b4/e54ad782-64b2-46a7-ad84-2cce03fb6a2d_53ddbeda7c7d4b6eb26f74e5e0c405fb.png?v=eb58efff1643caf8d17a779052ffb7a0',
    scale: 1.4,
  },
  {
    name: 'Cisco',
    logo: 'https://storage.readdy-site.link/project_files/d19cdf12-b626-4056-8bec-014908ede6b4/21a3f677-1aca-4af8-9f5a-47351d5a2ce8_cisco.png?v=1a16059abd8035d750acf33bd70c9838',
    scale: 1,
  },
  {
    name: 'Intelbras',
    logo: 'https://storage.readdy-site.link/project_files/d19cdf12-b626-4056-8bec-014908ede6b4/6f0e99cf-bc1d-47d1-8048-5044a5d5ce2c_intelbras-logo-png_seeklogo-173651.png?v=3b5e8447a056ef98d3168f83f5695ca2',
    scale: 1.5,
  },
  {
    name: 'Hikvision',
    logo: 'https://storage.readdy-site.link/project_files/d19cdf12-b626-4056-8bec-014908ede6b4/54b0215d-e57a-421c-9d5e-719d3364c9db_hikvision.jpg?v=b0eb14de5ca4dced3652e0983b142bfe',
    scale: 1,
  },
  {
    name: 'TP-Link',
    logo: 'https://storage.readdy-site.link/project_files/d19cdf12-b626-4056-8bec-014908ede6b4/51fa5aba-4f82-4861-ac16-74db3ebd0c7c_tplink.png?v=b4805f2437f0233c7eca3e6cf9c5e72a',
    scale: 1,
  },
  {
    name: 'MikroTik',
    logo: 'https://storage.readdy-site.link/project_files/d19cdf12-b626-4056-8bec-014908ede6b4/99eaa0c2-5efc-414b-83b1-557e9309bb10_MikroTik.png?v=b7aee688b90fef11a0eab785770a6d57',
    scale: 1,
  },
  {
    name: 'Unifi',
    logo: 'https://storage.readdy-site.link/project_files/d19cdf12-b626-4056-8bec-014908ede6b4/142e5962-d797-496e-881d-515500460669_unifi-logo.png?v=5d38479035423e8d692d07fe2313dbfd',
    scale: 1,
  },
];

const TRACK = [...PARTNERS, ...PARTNERS];

export default function TechPartnersSection() {
  return (
    <section className="bg-brand-bg py-20 border-t border-brand-border overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-12">
        <div className="text-center">
          <span className="text-neon-green text-xs font-bold tracking-widest uppercase mb-3 block">
            Tecnologias que utilizamos
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            Trabalhamos com as melhores tecnologias do mercado
          </h2>
          <p className="text-gray-400 max-w-xl mx-auto text-sm">
            Equipamentos de alto padrão selecionados para garantir estabilidade, segurança e performance na sua infraestrutura.
          </p>
        </div>
      </div>

      {/* Marquee wrapper */}
      <div className="relative">
        {/* Fade left */}
        <div className="absolute left-0 top-0 h-full w-32 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to right, var(--color-brand-bg, #0a0a0a), transparent)' }}
        />
        {/* Fade right */}
        <div className="absolute right-0 top-0 h-full w-32 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to left, var(--color-brand-bg, #0a0a0a), transparent)' }}
        />

        <div className="flex overflow-hidden">
          <div
            className="flex gap-5 items-center"
            style={{
              animation: 'marquee 32s linear infinite',
              width: 'max-content',
            }}
          >
            {TRACK.map((partner, i) => (
              <div
                key={`${partner.name}-${i}`}
                className="flex items-center justify-center flex-shrink-0 cursor-pointer transition-all duration-300 group"
              >
                <div className="bg-white rounded-2xl px-6 py-4 flex items-center justify-center transition-all duration-300 group-hover:scale-105 group-hover:shadow-[0_0_18px_rgba(0,255,136,0.3)]" style={{ width: '160px', height: '80px' }}>
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="max-w-full max-h-full object-contain filter grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                    style={{ transform: `scale(${partner.scale})`, mixBlendMode: 'multiply' }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}
